import '@fontsource/roboto';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { StytchB2BProvider } from '@stytch/react/b2b';
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AlertProvider from './components/common/alert/AlertProvider';
import ToastProvider from './components/common/toast/ToastProvider';
//import TokenAuthenticator from './components/stytch/TokenAuthenticator';
import { useStytchB2BClient } from '@stytch/react/b2b';
import TokenAuthenticator from './components/stytch/TokenAuthenticator';
import LocalizedStringsProvider from './localization/LocalizedStringsProvider';
import "./polyfills/string.toTitleCase";
import { theme } from './theme'; // pre-created theme object
import CurrentUserProvider from './providers/currentUser/CurrentUserProvider';

// Initialize the Stytch client using our public token
const stytch = new StytchB2BUIClient(
    import.meta.env.VITE_STYTCH_PUBLIC_TOKEN as string,
);

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <StytchB2BProvider stytch={stytch}>
            <TokenAuthenticator>
                <QueryClientProvider client={queryClient}>
                    <CurrentUserProvider>
                        <ThemeProvider theme={theme} defaultMode="system" disableTransitionOnChange>
                            <LocalizedStringsProvider>
                                <AlertProvider>
                                    <ToastProvider>
                                        <CssBaseline />
                                        <App />
                                    </ToastProvider>
                                </AlertProvider>
                            </LocalizedStringsProvider>
                        </ThemeProvider>
                    </CurrentUserProvider>
                </QueryClientProvider>
            </TokenAuthenticator>
        </StytchB2BProvider>
    </React.StrictMode>
);

export default function SessionSyncer() {
    const stytch = useStytchB2BClient();
    //const { session } = useStytchMemberSession();

    useEffect(() => {
        const jwt = stytch.session.getTokens()?.session_jwt;
        if (jwt) {
            sessionStorage.setItem("touchtab-session-jwt", jwt);
            console.debug("Refreshed JWT at", new Date().toISOString());
        }
    }, [stytch.session]);

    return null;
}